import { clsx } from 'clsx';

const variants = {
  gold: 'btn-gold',
  green: 'btn-green',
  blue: 'btn-blue',
  ghost: 'border-2 border-accent/50 text-accent font-urban font-bold rounded-xl px-6 py-3 hover:border-accent transition-colors active:scale-95',
  danger: 'font-urban font-bold rounded-xl px-6 py-3 text-white bg-pirate-red border-2 border-red-800 active:scale-95',
};

export default function Button({ children, variant = 'green', className, disabled, onClick, type = 'button', fullWidth = false }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        variants[variant],
        fullWidth && 'w-full',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      {children}
    </button>
  );
}
